//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'CRB65',
  data() {
    return {
      form:{
        confusion:'0',
        respiratoryRate:'0',
        bloodPressure:'0',
        age:'0',
      },
      hasScore:false,
      disabled:false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        let result = form.confusion + form.respiratoryRate + form.bloodPressure + form.age
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/CRB65.vue